// extracted by mini-css-extract-plugin
module.exports =  {"row--first":"_25d45facb5--row--first--Tv6jx","row--first--phone":"_25d45facb5--row--first--phone--gHZ4j","row--second--phone":"_25d45facb5--row--second--phone--WNFA_"};